import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const RelationshipWithMutualCompany = ({ refRelation }) => {
  const data = useLocation();

  const [RelationshipWithMutualCompany, setRelationshipWithMutualCompany] =
    useState({
      relation: data.state.data.RelationshipWithMutualCompany.relation || "",
    });

  return (
    <div className="section">
      <div className="tittleupdatebox">
        <p className="tittleupdate">Relación con la Mutual</p>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate">Tipo de relación:</label>
          <select
            ref={refRelation}
            className="inputupdate"
            defaultValue={RelationshipWithMutualCompany.relation}
            onChange={(e) =>
              setRelationshipWithMutualCompany({
                ...RelationshipWithMutualCompany,
                relation: e.target.value,
              })
            }
          >
            <option value="Proveedor">Proveedor</option>
            <option value="Fondista">Fondista</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default RelationshipWithMutualCompany;
